<div class="card-container">
  <div class="room-card-image">
    @if (roomDetailsModel.photos) {
      @if (isMobileScreen()) {
        <rds-carousel
          [showButtons]="true"
          [autoplay]="false"
          class="room-card-image">
          @for (
            carouselItem of roomDetailsModel.photos;
            track carouselItem.id
          ) {
            <rds-carousel-item>
              <div class="carousel-image">
                <img [ngSrc]="carouselItem.url" alt="Room" fill />
              </div>
            </rds-carousel-item>
          }
        </rds-carousel>
        <div class="gallery-icon">
          <button rds-icon-button (click)="showGallery()">
            <rds-icon
              icon="image_photo_library"
              namespace="outlined"
              style="color: white"></rds-icon>
          </button>
        </div>
      } @else {
        <img
          tabindex="1"
          alt="room photo"
          (keyup.enter)="showGallery()"
          [ngSrc]="roomDetailsModel.photos[0].url"
          fill
          (click)="showGallery()"
          class="image-cursor" />
      }
    }
  </div>
  <div class="room-details">
    <div class="details-section">
      <div class="details-section">
        <p class="ui-label-s-bold">Location</p>
        <p class="ui-body-l">
          {{ roomDetailsModel.siteName }} {{ roomDetailsModel.buildingName }}
          {{ roomDetailsModel.floorCode }} {{ roomDetailsModel.roomNumber }}
        </p>
      </div>
      <div class="details-section">
        <p class="ui-label-s-bold">Space up to</p>
        <p class="ui-body-l">{{ roomDetailsModel.capacity }} people</p>
      </div>
      @if (roomDetailsModel.description) {
        <div class="details-section">
          <p class="ui-label-s-bold">Description</p>
          <div
            class="ui-body-l"
            markdown
            [data]="roomDetailsModel.description"></div>
        </div>
      }
      @if (roomDetailsModel.features && roomDetailsModel.features.length > 0) {
        <div class="details-section">
          <p class="ui-label-s-bold">Room includes</p>

          <p class="ui-body-l">
            @for (
              feature of roomDetailsModel.features;
              track feature.id;
              let last = $last
            ) {
              {{ feature.name + (last ? '' : ',') }}
            }
          </p>
        </div>
      }
      @if (availableServices.length > 0) {
        <div class="details-section">
          <p class="ui-label-s-bold">Available Services</p>
          <p class="ui-body-l">
            @for (
              service of availableServices;
              track service.id;
              let last = $last
            ) {
              {{ service.name + (last ? '' : ',') }}
            }
          </p>
        </div>
      }
      @if (duration && (duration.maxDuration || duration.minDuration)) {
        <div class="details-section">
          <p class="ui-label-s-bold">Meeting duration</p>
          @if (duration.minDuration) {
            <p class="ui-body-l">Minimum: {{ duration.minDuration }}</p>
          }
          @if (duration.maxDuration) {
            <p class="ui-body-l">Maximum: {{ duration.maxDuration }}</p>
          }
        </div>
      }
      <!--      @if (layouts.length > 0) {
        <rds-form-field labelPosition="top">
          <rds-control-label>
            Available Layouts
            <rds-icon icon="circle_info" namespace="outlined"> </rds-icon>
          </rds-control-label>
          <rds-select [formControl]="layoutControl">
            @for (layout of layouts; track layout.layoutDexUUID) {
              <rds-select-option [value]="layout">
                {{ layout.layoutName }}
              </rds-select-option>
            }
          </rds-select>
        </rds-form-field>
        <div class="layout-details">
          @if (layoutControl.value) {
            <div class="layout-info">
              <p class="ui-label-s">
                Layout capacity:
                {{ layoutControl.value.capacity.min }}
                -
                {{ layoutControl.value.capacity.max }}
              </p>
              <p class="ui-label-s">Layout setup time:</p>
              <p class="ui-label-s">
                {{ layoutControl.value.setupTime.before }}
                minutes before -
                {{ layoutControl.value.setupTime.after }}
                minutes after
              </p>
            </div>
          }
          @if (layoutControl.value && layoutControl.value.imageURL) {
            <div class="layout-image">
              <img
                alt="layout-image"
                [ngSrc]="layoutControl.value.imageURL"
                fill />
            </div>
          }
        </div>
      }-->
    </div>
    <a rds-link standalone size="s" [href]="reportRoomUrl" target="_blank">
      <div class="external-link">
        Report this room
        <rds-icon namespace="outlined" icon="external_link" />
      </div>
    </a>
  </div>
</div>
